// src/components/Filters.jsx
import React from 'react';
import Select from 'react-select';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const Filters = ({ filters, selectedFilters, onFilterChange, onSearchChange }) => {
  const handleChange = (selectedOptions, { name }) => {
    const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    const updatedFilters = { ...selectedFilters, [name]: selectedValues };
    onFilterChange(updatedFilters);
  };

  return (
    <div className="filters mt-4 mb-4 flex flex-wrap items-center">
      <div className="mr-4 mb-2">
        <TextField
          placeholder="Search"
          variant="outlined"
          size="small"
          style={{ width: '275px' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <div className="mr-4 mb-2">
        <Select
          isMulti
          name="status"
          options={filters.status.map((filter) => ({ value: filter, label: filter }))}
          value={selectedFilters.status.map((filter) => ({ value: filter, label: filter }))}
          className="basic-multi-select"
          classNamePrefix="select"
          placeholder="Select status"
          onChange={handleChange}
          style={{ width: '150px' }}
        />
      </div>
      <div className="mr-4 mb-2">
        <Select
          isMulti
          name="city"
          options={filters.city.map((filter) => ({ value: filter, label: filter }))}
          value={selectedFilters.city.map((filter) => ({ value: filter, label: filter }))}
          className="basic-multi-select"
          classNamePrefix="select"
          placeholder="Select city"
          onChange={handleChange}
          style={{ width: '150px' }}
        />
      </div>
    </div>
  );
};

export default Filters;
